
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-r from-sunset-yellow/20 to-dusty-rose/20 border-t border-peach-orange/20 py-3 sm:py-4 md:py-6">
      <div className="w-full px-4 sm:px-6 flex flex-col sm:flex-row justify-between items-center gap-3 sm:gap-4">
        <p className="text-xs sm:text-sm text-sunset-medium text-center sm:text-left">
          © 2025 FollowTheSun. All rights reserved.
        </p>
        <div>
          <Button 
            variant="link" 
            className="text-xs sm:text-sm p-2 sm:p-4 h-auto" 
            asChild
          >
            <Link to="/submit-terrace">Submit a terrace</Link>
          </Button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
